import { render, staticRenderFns } from "./ChooseYongliao.vue?vue&type=template&id=1fa1da2c&scoped=true&"
import script from "./ChooseYongliao.vue?vue&type=script&lang=js&"
export * from "./ChooseYongliao.vue?vue&type=script&lang=js&"
import style0 from "./ChooseYongliao.vue?vue&type=style&index=0&id=1fa1da2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa1da2c",
  null
  
)

export default component.exports